import { render, staticRenderFns } from "./BatchClaimList.vue?vue&type=template&id=bfe7b668&scoped=true"
import script from "./BatchClaimList.vue?vue&type=script&lang=ts"
export * from "./BatchClaimList.vue?vue&type=script&lang=ts"
import style0 from "./BatchClaimList.vue?vue&type=style&index=0&id=bfe7b668&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfe7b668",
  null
  
)

export default component.exports